import { Route, Routes } from "react-router-dom";
import CreateBookForm from "./create/CreateBookForm";

import BookGallery from "./gallery";
import BookSortGallery from "./gallery/sort";
import BookGroupGallery from "./gallery/group";
import UpdateBookIndex from "./update/UpdateBookIndex";

import VerticalMenu from '../../components/VerticalMenu'
import { Col, Row} from "react-bootstrap";
import { useAppStore } from '../../context/state'
/**
 * 
 * @param {{menu, letters, gallery, lang: json}} props 
 * @returns 
 */
export default function BookIndex(props) {

  const { commonmenu } = useAppStore.getState().settings

  return (
    <Row>
      <Col xs={{ span: 12, order: 2 }} sm={{ span: 12, order: 2 }} md={{ span: 3, order: 1 }} xl={2} style={{ /*minHeight:'100vh' */ }}>
        <VerticalMenu url="/editorial/books" menu={commonmenu} />
      </Col>
      <Col xs={{ span: 12, order: 1 }} sm={{ span: 12, order: 1 }} md={{ span: 9, order: 2 }} xl={10}>
       <Routes>
          <Route path="/" exact element={<BookGallery {...props} haveSearchText={false} />} />
          <Route path="/:searchText/search" exact element={<BookGallery {...props} haveSearchText={true} />} />
          <Route path="/:id" exact element={<BookGallery {...props} />} /> {/* <Route path="/:id" exact element={<BookDetailed {...props} />} /> */}
          
          <Route path="/:field/:order/sort" exact element={<BookSortGallery {...props} />} />
          <Route path="/:field/group" exact element={<BookGroupGallery {...props} />} />

          <Route path="/create" exact element={<CreateBookForm {...props} />} />
          <Route path="/update" exact element={<UpdateBookIndex {...props} />} />
          <Route path="*" exact element={<BookGallery {...props} haveSearchText={false} />} />
        </Routes>
      </Col>
    </Row>
  )
}